import { createContext as e, useCallback as r, Children as n, useMemo as a, createElement as u, forwardRef as o, useState as l, useRef as t, useContext as c, useEffect as i } from "react";

function d(e, r) {
  var n = {};

  for (var a in e) {
    Object.prototype.hasOwnProperty.call(e, a) && -1 === r.indexOf(a) && (n[a] = e[a]);
  }

  return n;
}

var v = e({});

function s(e) {
  var o = e.labelledBy,
      l = e.children,
      t = e.value,
      c = d(e, ["labelledBy", "children", "value"]),
      i = r(function (e) {
    c.onChange && c.onChange(e);
  }, []),
      s = n.map(l, function (e) {
    return e.props.value;
  }),
      f = a(function () {
    return {
      value: t,
      otherRadioValues: s,
      setChecked: i
    };
  }, [s, t]);
  return u(v.Provider, {
    value: f
  }, u("div", {
    role: "radiogroup",
    "aria-labelledby": o,
    "data-palmerhq-radio-group": !0
  }, l));
}

var f = o(function (e, n) {
  var a = e.children,
      o = d(e, ["children"]),
      s = l(!1),
      f = s[0],
      h = s[1],
      p = t(null),
      b = c(v),
      g = b.otherRadioValues,
      k = b.value,
      y = b.setChecked,
      m = g.findIndex(function (e) {
    return e == o.value;
  }),
      C = g.length - 1;
  i(function () {
    k === o.value && (n && null !== n.current ? n.current.focus() : null !== p.current && p.current.focus());
  }, [k, o.value, n]);
  var B = r(function (e) {
    e.persist();
    var r = !1;

    switch (e.keyCode) {
      case 32:
      case 13:
        y(o.value), r = !0;
        break;

      case 38:
      case 37:
        y(0 === m ? g[C] : g[m - 1]), r = !0;
        break;

      case 40:
      case 39:
        y(m === C ? g[0] : g[m + 1]), r = !0;
    }

    r && (e.stopPropagation(), e.preventDefault());
  }, [a, g, o.value, C, m]),
      x = r(function () {
    y(o.value);
  }, [o.value]),
      O = r(function (e) {
    o.onBlur && o.onBlur(e), h(!1);
  }, []),
      q = r(function (e) {
    o.onFocus && o.onFocus(e), h(!0);
  }, []);
  return u("div", Object.assign({}, o, {
    role: "radio",
    tabIndex: k === o.value ? 0 : -1,
    "aria-checked": k === o.value,
    onBlur: O,
    onFocus: q,
    onClick: x,
    onKeyDown: B,
    "data-palmerhq-radio": !0,
    "data-palmerhq-radio-focus": f,
    ref: function ref(e) {
      n && (n.current = e), p.current = e;
    },
    children: a
  }));
});
export { s as RadioGroup, f as Radio };